import React, { useContext, ReactElement } from 'react';

import { ActionTypes, AssetDetailsDispatch } from '@components/asset/modal/tabs/edit/EditTabTypes';

import UploadArea from '@components/common/filestack_uploader/upload_area';
import AttachmentUppy from '@components/common/uppy/attachment_uppy';
import assetModalContext from '@components/asset/modal/tabs/edit/asset_modal_context';
import { tempAttachmentTemplate } from '../helpers';

interface UploaderScopedContext {
  state: {
    initialData: {
      assetKey: string;
    };
  };
  dispatch: AssetDetailsDispatch;
}

const AttachmentUploader = (): ReactElement => {
  const { state, dispatch }: UploaderScopedContext = useContext(assetModalContext);
  const handleNewAttachment = (files): any => (
    dispatch({
      type: ActionTypes.UploadNewAttachment,
      payload: files.map((file) => tempAttachmentTemplate(file)),
    })
  );

  if (!BFG.hasFeature('uppy_uploader_features')) {
    return (
      <UploadArea
        assetKey={state.initialData.assetKey}
        onUpload={handleNewAttachment}
        uniqDomElement={`attachment-fs-${state.initialData.assetKey}`}
        uploadType="attachment"
      />
    );
  }

  if (BFG.hasFeature('uppy_uploader_features')) {
    return (
      <AttachmentUppy
        assetKey={state.initialData.assetKey}
        onUpload={handleNewAttachment}
      />
    );
  }

  return null;
};

export default AttachmentUploader;
